import React from "react";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import type Region from "entities/region";
import RegionsViewModel from "viewModels/timeCharges/distributorEnums/regions/regionsViewModel";
import ListView from "views/common/list";

const RegionsView: ViewComponent<RegionsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<Region>[] = [
    { property: "name", title: vm.translateAttribute("name") },
    { property: "nutsCode", title: vm.translateAttribute("nutsCode") },
    { property: "licensePlateLetter", title: vm.translateAttribute("licensePlateLetter") },
  ];

  return <ListView vm={vm} columns={columns} />;
});

registerView(RegionsView, RegionsViewModel);
